import { render, staticRenderFns } from "./dsLichCongTac.vue?vue&type=template&id=6107b8ac&"
import script from "./dsLichCongTac.vue?vue&type=script&lang=js&"
export * from "./dsLichCongTac.vue?vue&type=script&lang=js&"
import style0 from "./dsLichCongTac.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports